import { useState, useMemo } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import { API_URL } from "../../../utils/constant";
import SalesBillVariantPosModel from "./sales_variant_model";

const SalesBillModelReallocate = ({ show, onClose, heading, initialData }) => {
  /* =======================
     STATES
  ========================*/
  const [selectedOldSerials, setSelectedOldSerials] = useState([]);
  const [newVariants, setNewVariants] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showVariantModal, setShowVariantModal] = useState(false);

  /* =======================
     FLATTEN OLD SERIALS
  ========================*/
  const allOldSerials = useMemo(() => {
    if (!initialData?.product_data) return [];
    return initialData.product_data.flatMap((p) =>
      p.serial_nos.map((s) => ({
        product_id: p.product_id,
        product_name: p.product_name,
        price: Number(p.price),
        gst: p.gst,
        gst_included: p.gst_included,
        variant_id: s.variant_id,
        serial_no: s.serial_no,
      }))
    );
  }, [initialData]);

  /* =======================
     SELECT OLD SERIAL
  ========================*/
  const toggleOldSerial = (serial) => {
    setSelectedOldSerials((prev) => {
      const exists = prev.find((s) => s.variant_id === serial.variant_id);
      if (exists) return prev.filter((s) => s.variant_id !== serial.variant_id);
      return [...prev, serial];
    });
    setNewVariants([]);
  };

  /* =======================
     SEARCH PRODUCT
  ========================*/
  const searchProduct = async () => {
    if (!searchText.trim()) return;

    const company = JSON.parse(localStorage.getItem("company"));
    const companyId = company?.company?.id;

    try {
      const res = await axios.get(
        `${API_URL}/pos/products/${companyId}/search?q=${encodeURIComponent(
          searchText
        )}`
      );
      if (res.data.success) setSearchResults(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  /* =======================
     ADD OR REMOVE NEW VARIANT
  ========================*/
  const handleAddVariant = ({ product, variant_id, serial_no, remove }) => {

    console.log('proudt data',  product);
    if (remove) {
      setNewVariants((prev) =>
        prev.filter((v) => v.variant_id !== variant_id)
      );
      return;
    }

    if (newVariants.length >= selectedOldSerials.length) {
      alert("Cannot add more new items than selected old serials");
      return;
    }

    setNewVariants((prev) => [
      ...prev,
      {
        product_id: product.parent_product_id,
        product_name: product.name,
        price: Number(product.sale_cost),
        gst: product.gst || "12.00",
        gst_included: true,
        serial_no,
        variant_id,
      },
    ]);

    console.log('resjpoasndf a', newVariants);
  };

  /* =======================
     PRICE DIFFERENCE
  ========================*/
  const oldTotal = selectedOldSerials.reduce((s, i) => s + i.price, 0);
  const newTotal = newVariants.reduce((s, i) => s + i.price, 0);
  const diff = newTotal - oldTotal;

  /* =======================
     BUILD FINAL product_data
  ========================*/
 const buildFinalProductData = () => {
  const remainingOld = allOldSerials.filter(
    o => !selectedOldSerials.some(s => s.variant_id === o.variant_id)
  );

  const finalItems = [...remainingOld, ...newVariants];

  const grouped = {};

  finalItems.forEach(item => {

    console.log('product data', item);
    const key = `${item.product_name}`;

    if (!grouped[key]) {
      grouped[key] = {
        product_id: item.product_id,
        product_name: item.product_name,
        gst: item.gst,
        gst_included: item.gst_included,
        price: item.price,          // unit price
        qty: 0,
        amount: 0,
        serial_nos: []
      };
    }

    grouped[key].qty += 1;
    grouped[key].amount += item.price;
    grouped[key].serial_nos.push({
      serial_no: item.serial_no,
      variant_id: item.variant_id
    });
  });

  return Object.values(grouped);
};

  /* =======================
     CONFIRM
  ========================*/
  const confirmExchange = async () => {
    const company = JSON.parse(localStorage.getItem("company"));
    const companyId = company?.company?.id;

     const payload = {
        sale_bill_id: initialData.id,
        product_data: buildFinalProductData(),

        // 👇 OLD VARIANTS BEING EXCHANGED
        removed_variants: selectedOldSerials.map(s => ({
        variant_id: s.variant_id,
        serial_no: s.serial_no
        })),

        // (optional but recommended)
        price_difference: newVariants.reduce((s, i) => s + i.price, 0) -
                        selectedOldSerials.reduce((s, i) => s + i.price, 0)
    };

    console.log("Exchange Payload", payload);
    try {
      await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`,payload);
      alert("Exchange completed");
      window.location.reload();
      onClose();
    } catch (error) {
      console.error(error);
      alert("Something went wrong!");
    }
  };

  /* =======================
     UI
  ========================*/
  return (
    <>
      <Modal show={show} onClose={onClose} heading={heading}>
        {/* OLD SERIALS */}
        <h5>Select Old Serials</h5>
        {allOldSerials.map((s) => (
          <button
            key={s.variant_id}
            className={`btn me-2 mb-2 ${
              selectedOldSerials.some((x) => x.variant_id === s.variant_id)
                ? "btn-danger"
                : "btn-outline-secondary"
            }`}
            onClick={() => toggleOldSerial(s)}
          >
            {s.product_name}
            <br />
            <small>{s.serial_no}</small>
          </button>
        ))}

        {/* ADD NEW PRODUCT */}
        {selectedOldSerials.length > 0 && (
          <>
            <hr />
            <h6>
              Add New Product ({newVariants.length}/{selectedOldSerials.length})
            </h6>

            <div className="input-group mb-3">
              <input
                className="form-control"
                placeholder="Search product"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <button className="btn btn-primary" onClick={searchProduct}>
                Search
              </button>
            </div>

            <div className="row">
              {searchResults.map((prod) => (
                <div className="col-4 mb-3" key={prod.id}>
                  <div
                    className="card p-2 text-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSelectedProduct(prod);
                      setShowVariantModal(true);
                    }}
                  >
                    <img
                      src={`${API_URL}/${prod.product_image}`}
                      alt={prod.name}
                      onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '../../logo.png'; // fallback logo on load error
                      }}
                      style={{ height: 80, objectFit: "contain" }}
                    />
                    <p className="mb-0">{prod.name}</p>
                  </div>
                </div>
              ))}
            </div>

            {newVariants.length > 0 && (
              <>
                <hr />
                <h6>
                  New Selected Products ({newVariants.length}/{selectedOldSerials.length})
                </h6>

                <table className="table table-bordered align-middle">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Product</th>
                      <th>Serial</th>
                      <th>Price</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {newVariants.map((item, index) => (
                      <tr key={item.variant_id}>
                        <td>{index + 1}</td>
                        <td>{item.product_name}</td>
                        <td>{item.serial_no}</td>
                        <td>₹{item.price}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() =>
                              handleAddVariant({
                                variant_id: item.variant_id,
                                remove: true,
                              })
                            }
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </>
        )}

        {/* PRICE */}
        {selectedOldSerials.length > 0 && (
          <>
            {diff > 0 && <div className="alert alert-warning">Exchange Product Cost ₹{oldTotal} and selected New ₹{newTotal} - Add ₹{diff}</div>}
            {diff < 0 && (
              <div className="alert alert-info">Exchange Product Cost ₹{oldTotal} and selected New ₹{newTotal} -  Return ₹{Math.abs(diff)}</div>
            )}
            {diff === 0 && <div className="alert alert-success">No Price difference</div>}
          </>
        )}

        {/* ACTIONS */}
        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-secondary" onClick={()  => {
            setNewVariants([]);
            onClose();
          }}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            disabled={newVariants.length === 0}
            onClick={confirmExchange}
          >
            Confirm Exchange
          </button>
        </div>
      </Modal>

      {/* VARIANT MODAL */}
      <SalesBillVariantPosModel
        show={showVariantModal}
        onClose={() => setShowVariantModal(false)}
        heading="Select Serial"
        initialData={selectedProduct}
        cart={newVariants}
        addCart={handleAddVariant}
      />
    </>
  );
};

export default SalesBillModelReallocate;
